import { AlertTriangle } from "lucide-react";
import { Badge } from "@/components/ui/badge";

/** Shown instead of "Connected" when the provider rejected the stored
 *  credentials, so the channel can't reply until the owner reconnects. */
export default function ReconnectNeededBadge() {
  return (
    <Badge
      variant="outline"
      className="border-amber-300 bg-amber-50 text-amber-700"
      data-testid="reconnect-needed"
    >
      <AlertTriangle className="mr-1 h-3 w-3" />
      Reconnect needed
    </Badge>
  );
}
